import { render, staticRenderFns } from "./check-your-physical-fitness.vue?vue&type=template&id=4db6c782&"
import script from "./check-your-physical-fitness.vue?vue&type=script&lang=js&"
export * from "./check-your-physical-fitness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports